import { cloneDeep, isEmpty } from "lodash";

export const updateData = (data, required) => {
  if (isEmpty(data)) return;
  let copyData = cloneDeep(data);
  copyData.jsonSchema.required = required;
  return copyData;
};
